import { useContext } from 'react';
import { useParams } from 'react-router';

import { ConfigContext } from 'Context/config';

const useBrandName = () => {
  const params = useParams<{ brand?: string }>();
  const { configState: { brandData = {} } } = useContext(ConfigContext);

  return brandData?.brand?.display_name ?? brandData?.brands?.find(({ slug }) => slug === params.brand)?.display_name;
};

export default useBrandName;
